import {load} from '@shopify/theme-sections';

import '../sections/search';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
